import { render, staticRenderFns } from "./DetailCompany.vue?vue&type=template&id=84a10c92&scoped=true&"
import script from "./DetailCompany.vue?vue&type=script&lang=js&"
export * from "./DetailCompany.vue?vue&type=script&lang=js&"
import style0 from "./DetailCompany.vue?vue&type=style&index=0&id=84a10c92&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a10c92",
  null
  
)

export default component.exports